// hooks/useVerifyEmailToken.ts
import { useState, useEffect } from 'react';
import { AthenaCore } from 'athena-core';
import { V } from 'vitest/dist/chunks/reporters.d.BFLkQcL6.js';

enum VerificationType {
  SignUp = 'verify-signup-email',
  PasswordReset = 'verify-reset-email',
}

export const useVerifyEmailToken = (token: string | null) => {
  const [signUpVerified, setSignUpVerified] = useState<boolean>(false);
  const [passwordResetVerified, setPasswordResetVerified] =
    useState<boolean>(false);
  // const [verified, setVerified] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const verifyToken = async (verificationType: VerificationType) => {
    try {
      setLoading(true);

      console.log(verificationType);
      console.log(token);

      const response = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/api/auth/${verificationType}?token=${token}`,
        {
          method: 'PATCH',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        AthenaCore.throwError({
          status: response.status,
          message: 'Verification failed. Invalid or expired token.',
        });
      }

      await response.json();

      AthenaCore.openModal({
        title: 'Email Verified',
        message: 'Your email has been successfully verified.',
        type: 'info',
      });

      setLoading(false);
      if (verificationType === VerificationType.PasswordReset)
        setPasswordResetVerified(true);
      else if (verificationType === VerificationType.SignUp)
        setSignUpVerified(true);
    } catch (error) {
      AthenaCore.openModal({
        title: 'Verification Failed',
        message:
          error instanceof Error
            ? error.message
            : 'Unknown error during email verification.',
        type: 'error',
      });

      setLoading(false);
    }
  };

  const verifySignUpToken = async () => {
    if (!token) return;
    await verifyToken(VerificationType.SignUp);
  };

  const verifyPasswordResetToken = async () => {
    if (!token) return;

    await verifyToken(VerificationType.PasswordReset);
  };

  return {
    loading,
    signUpVerified,
    passwordResetVerified,
    verifyPasswordResetToken,
    verifySignUpToken,
  };
};
